<template>
  <section>
    <h4>{{ index }}.{{ index_index }}.1 {{ ipg.name }}</h4>

    <b-row>
      <b-col>
        <h4>Dettaglio: andamento mensile</h4>

        <apexchart type="bar" :options="chart.options" :series="chart.series" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table :fields="table.fields" :items="table.items">
          <template slot="vs1" slot-scope="data">
            <font-awesome-icon style="color: green" icon="check" v-if="data.value == 1" />
            <font-awesome-icon style="color: red" icon="times" v-if="data.value == -1" />
          </template>
          <template slot="vs2" slot-scope="data">
            <font-awesome-icon style="color: green" icon="check" v-if="data.value == 1" />
            <font-awesome-icon style="color: red" icon="times" v-if="data.value == -1" />
          </template>
        </b-table>
      </b-col>
    </b-row>
    <div>
        <apexchart type="bar" :options="chart2.options" :series="chart2.series" />
    </div>
    <div>
        <p>Per consentire un'analisi grafica più efficace si riporta il grafico seguente:</p>
    </div>
    <div>
        <apexchart type="line" :options="chart3.options" :series="chart3.series" />
    </div>
  </section>
</template>

<script>
var moment = require('moment');

export default {
  name: "ipg",
  props: ['siteGuid', 'month', 'months', 'index', 'vector', 'ipg', 'index_index'],

  data() {
    return {
      currentYear: 0,
      year1: 0,
      year2: 0,
      chart: {
        options: {
          colors: this.$store.state.colors,
          chart: {
            toolbar: {
              show: false
            },
            height: 240,
            width: 900,
            animations: {
              enabled: false
            }
          },
          yaxis: {
            labels: {
              formatter: (v) => this.f(v, 3)
            }
          },
          xaxis: {
            categories: []
          },
          dataLabels: {
            enabled: false
          }
        },
        series: []
      },
      chart2: {
        options: {
          colors: this.$store.state.colors,
          chart: {
            type: 'line',
            animations: {
              enabled: false,
              toolbar: {
                show: false
              },
            },
            height: 400,
            width: 940,
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: []
          },
          yaxis: {
            labels: {
              formatter: (v) => this.f(v, 3)
            }
          },
          markers: {
            size: 4,
            shape: "square"
          },
          stroke: {
            width: 3,
            curve: 'straight'
          },
          dataLabels: {
            enabled: true,
            enabledOnSeries: [0],
            formatter: (v) => this.f(v, 3),
            style: {
              colors: ['#333']
            }
          },
        },
        series: []
      },
      chart3: {
        options: {
          colors: this.$store.state.colors,
          chart: {
            type: 'line',
            animations: {
              enabled: false,
              toolbar: {
                show: false
              },
            },
            height: 400,
            width: 940,
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: []
          },
          yaxis: {
            labels: {
              formatter: (v) => this.f(v, 3)
            }
          },
          markers: {
            size: 4,
            shape: "square"
          },
          stroke: {
            width: 3,
            curve: 'straight'
          },
          dataLabels: {
            enabled: true,
            enabledOnSeries: [0],
            formatter: (v) => this.f(v, 3),
            style: {
              colors: ['#333']
            }
          },
        },
        series: []
      },
      table: {
        fields: [],
        items: []
      }
    }
  },

  created() {
    console.log(this.ipg)

    var options = _.cloneDeep(this.chart.options)
    options.xaxis.categories = this.monthLabels

    this.chart.options = options
    this.refresh()
  },

  methods: {
    refresh() {

      var options = _.cloneDeep(this.chart.options)
      options.yaxis.title = {
        text: this.ipg.name + "[ " + this.ipg.mu + "]"
      }
      this.chart.options = options

      let fields = []
      fields.push({ key: 'mese', label: 'Mese' })

      this.currentYear = parseInt(moment(this.month, 'MM-YYYY').format('YYYY'))
      this.year1 = this.currentYear - 1
      this.year2 = this.currentYear - 2

      this.chart.series = []
      this.table.items = []
      console.log(this.ipg)
      let years = _.sortedUniq(this.ipg.values.map(e => e.year)).slice(-3)
      years.forEach(y => {
        if(_.filter(this.ipg.values, { year : y }).length > 0) {
          this.chart.series.push({
            name: y,
            data: _.filter(this.ipg.values, { year : y }).map(ee => ee.IPG)
          })

          fields.push({ key: 'y' + y, label: y+'' })
        }
      })

      fields.push({ key: 'vs2', label: this.currentYear + " VS " + this.year2 })
      fields.push({ key: 'vs1', label: this.currentYear + " VS " + this.year1 })
      fields.push({ key: 'diff', label: '' })

      this.table.fields = fields

      for(var i=1; i<=12; i++) {
        var record = { mese: moment(i, 'M').format('MMMM'), vs1: '', vs2: '' }
        years.forEach(y => {
          var values = _.filter(this.ipg.values, { year : y })
          var value = values.find(v => v.month == i)
          record['y' + y] = value ? this.f(value.IPG) : "-"

          if(y == this.currentYear && record['y' + y] != "-") {
            let value2 = _.filter(this.ipg.values, { year : this.year2 }).find(v => v.month == i)
            if(value2) {
              record['vs2'] = value.IPG < value2.IPG ? 1 : -1
            }

            let value1 = _.filter(this.ipg.values, { year : this.year1 }).find(v => v.month == i)
            if(value1) {
              record['vs1'] = value.IPG < value1.IPG ? 1 : -1

              if(value.IPG != 0 && value1.IPG != 0) {
                if(record['vs1'] == 1) {
                  record['diff'] =  ((1 - (value1.IPG / value.IPG)) * 100).toFixed(2) + "%"
                } else {
                  record['diff'] = "+" + (((value.IPG / value1.IPG) - 1) * 100).toFixed(2) + "%"
                }
              }
            }
          }
        })
        this.table.items.push(record)
      }

      this.makeRollingCharts()
    },

    makeRollingCharts() {
      var options = _.cloneDeep(this.chart2.options)
      options.xaxis.categories = []

      this.months.forEach((m,i) => {
        let year = parseInt(moment(m, 'MM-YYYY').format('YYYY'))
        if(year >= this.year1)
          options.xaxis.categories.push(moment(m, 'MM-YYYY').format('MMM YY'))
      })

      this.chart2.options = options
      this.chart3.options = options

      this.chart2.series = []
      this.chart2.series.push({
        type: 'column',
        name: this.ipg.name,
        data: this.ipg.values.filter(v => v.year >= this.year1).map(v => v.IPG)
      })

      let rolling = {
        name: this.ipg.name + " Rolling",
        data: []
      }

      this.months.forEach((m,i) => {
        let year = parseInt(moment(m, 'MM-YYYY').format('YYYY'))

        if(year >= this.year1) {
          var totParam = 0
          var totVector = 0
          for(let j=1; j<=12; j++) {
            let date = moment(m, 'MM-YYYY')
            let prev = date.subtract(j, 'months')

            var el = this.ipg.values.find(v => v.date == prev.format('MM-YYYY'))
            totParam += el.parameterValue
            totVector += el.value
          }
          rolling.data.push(totVector / totParam)
        }
      })

      this.chart2.series.push(rolling)
      var options = _.cloneDeep(this.chart2.options)
      options.yaxis.title = {
        text: this.ipg.name + "[ " + this.ipg.mu + "]"
      }
      this.chart2.options = options

      this.chart3.series = []

      let average = _.reduce(rolling.data, function(sum, n) {
        return sum + n;
      }, 0) / rolling.data.length
      this.chart3.series.push({
        name: "Media",
        data: rolling.data.map(v => average)
      })
      this.chart3.series.push(rolling)

      var options = _.cloneDeep(this.chart3.options)
      options.yaxis.title = {
        text: this.ipg.name + "[ " + this.ipg.mu + "]"
      }
      this.chart3.options = options
    },

    f(v, n) {
      return this.$options.filters.formatDecimal(v, n)
    },
  },

  computed: {
    monthLabels() {
      return 'Gen_Feb_Mar_Apr_Mag_Giu_Lug_Ago_Set_Ott_Nov_Dic'.split('_')
    },
    vectorName() {
      return this.$store.state.vectors.list.find(v => v.code == this.vector).name
    },
    vectorMu() {
      return this.$store.state.vectors.list.find(v => v.code == this.vector).mu
    }
  },

  watch: {
    ipg() {
      this.refresh()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Report/H1_Indexes_ipg.vue